<section [class.open]="open">
  <ng-content></ng-content>
</section>
